<!-- SELECTOR -->
<p-selectbutton (onChange)="updateStorage($event)" [options]="options" [(ngModel)]="currentGroup" optionValue="group">
    <ng-template #item let-item>
        <i [class]="item.icon"></i>
    </ng-template>
</p-selectbutton>

@if(currentGroup === 'cards') {
    <ng-container [ngTemplateOutlet]="cardContent()">
    </ng-container>
}

@if(currentGroup === 'table') {
    <ng-container [ngTemplateOutlet]="tableContent()">
    </ng-container>
}
